import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/hr/payroll/runs')({
  component: RunsLayout,
})

function RunsLayout() {
  return <Outlet />
}
